import { BrowserRouter, Route, Switch } from "react-router-dom";
import OpenTokNetworkTest from "./components/NetworkTest";

require("dotenv").config();

const App = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={OpenTokNetworkTest} />
      </Switch>
    </BrowserRouter>
  );
};

export default App;
